import type { FragmentType } from "../../../../__generated__/gql";
import { graphql, useFragment } from "../../../../__generated__/gql";
import { Markdown } from "../../../_components/ui/markdown/markdown";

const Fragment = graphql(`
  fragment ContentFacilityDetails on ContentFacilityDetails {
    facilityAmenities {
      name
      descriptionMarkup
    }
    usageFeesDescriptionMarkup
    usageConditionsDescription
  }
`);

export function FacilityDetails({
  facilityDetailsFragment,
}: {
  facilityDetailsFragment: FragmentType<typeof Fragment>;
}) {
  const details = useFragment(Fragment, facilityDetailsFragment);
  return (
    <div className="flex flex-col gap-[20px] md:gap-[30px]">
      {details.facilityAmenities.length > 0 && (
        <div className="divide-sbeige grid grid-cols-1 divide-y">
          {details.facilityAmenities.map((amenity, i) => (
            <div
              key={i}
              className="grid grid-cols-1 gap-[10px] py-[20px] md:grid-cols-3 md:gap-0 md:py-[30px]"
            >
              <h3 className="text-[14px] md:text-[16px]">{amenity.name}</h3>
              <div className="text-[10px] md:col-span-2 md:text-[13px]">
                <Markdown>{amenity.descriptionMarkup}</Markdown>
              </div>
            </div>
          ))}
        </div>
      )}
      <div className="grid grid-cols-1 gap-y-[20px] text-[10px] md:text-[13px]">
        <div className="grid grid-cols-1 gap-y-[5px] md:grid-cols-3">
          <h3>
            <b>ご利用料金</b>
          </h3>
          <div className="md:col-span-2">
            <Markdown>{details.usageFeesDescriptionMarkup}</Markdown>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-y-[5px] md:grid-cols-3">
          <h3>
            <b>ご利用条件・備考</b>
          </h3>
          <p className="md:col-span-2">{details.usageConditionsDescription}</p>
        </div>
      </div>
    </div>
  );
}
